import React from 'react';
import { Typography } from '@mui/material';
import { LOGIN_LOGIN } from '../../constants';
import ButtonBox from '../../components/ButtonBox';
import '../../style/Login.css';

interface ResetSuccessProps {
    setLoginPage: React.Dispatch<React.SetStateAction<string>>;
}

const ResetSuccess: React.FC<ResetSuccessProps> = ({ setLoginPage }) => {
    const handleToLogin = () => {
        setLoginPage(LOGIN_LOGIN);
    };

    return (
        <>
            <Typography className='login_typography_title'>
                Reset successfully
            </Typography>
            <Typography className='login_typography_content'>
                Please login with new password
            </Typography>

            <ButtonBox
                text="Login"
                onClick={handleToLogin}
            />
        </>
    );
};

export default ResetSuccess;
